/* eslint-disable @typescript-eslint/no-namespace */
/**
 * Field-level Relationship Definitions
 */
export var CodeGenConnectionType;
(function (CodeGenConnectionType) {
    CodeGenConnectionType["HAS_ONE"] = "HAS_ONE";
    CodeGenConnectionType["BELONGS_TO"] = "BELONGS_TO";
    CodeGenConnectionType["HAS_MANY"] = "HAS_MANY";
})(CodeGenConnectionType || (CodeGenConnectionType = {}));
